<form class="ng-untouched ng-pristine ng-invalid" [formGroup]="form">
    <div class="lg:w-1/ mb-4">

        <div class="card shadow grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3 mx-0" *ngIf="showValided">
            <div class="step-personality px-2 sm:border-right-1 sm:border-200">
                <div class="title font-semibold text-xl mb-2">Étape 1</div>
                <div class="text-sm">Cliquez sur le <a class="link font-semibold underline"
                        href="https://www.16personalities.com/fr/test-de-personnalite" target="_blank"
                        title="lien">lien</a> pour effectuer votre test de personnalité.</div>
            </div>
            <div class="step-personality px-2">
                <div class="title font-semibold text-xl mb-2">Étape 2</div>
                <div class="label mb-1 text-sm">Saisissez le code reçu au bon format
                    <div style="color:var(--blue);" class="tooltip pi pi-info-circle">
                        <div class="tooltip-text text-sm">Ne renseignez que les 4 premiers caractères du code reçu.
                            Exemple : ESRT, UNTJ, ISGP.</div>
                    </div>
                </div>
                <input formControlName="selectedCode" type="text" (change)="verify()" placeholder="Ex : ISGP"
                    class="mb-1 bg-white border border-gray-300 text-gray-900 text-sm rounded-lg inline-block w-4 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 h-15 mr-2" />
                    <button type="button" class="text-white btn-login rounded-lg text-sm px-5 py-2.5 bg-blue font-semibold" (click)="onSaveTestPersonnality(this.recupIuf)" [disabled]="isDisable">
                        Valider
                    </button>
                    <p *ngIf="isNotValid" class="text-red text-sm"> Code Invalide</p>
            </div>
        </div>

        <!-- <div class="grid m-0" *ngIf="showValided" style="display:flex">
            <div class="label mb-2 text-sm"> Veuillez saisir votre code reçu avec les résultats de votre test de personnalité.</div>
            <div class="col-12 md:col-12 xl:col-6 px-0" >
                <input formControlName="selectedCode" type="text" placeholder="Code"  class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 h-15" />
            </div>
            <div class="col-12 md:col-12 xl:col-6" *ngIf="showValided">
                <div >
                    <button type="button"
                            class="text-white btn-login rounded-lg text-sm px-5 py-2.5 bg-blue font-semibold"
                            (click)="onSaveTestPersonnality(this.recupIuf)">
                                Valider
                    </button>
                </div>
            </div>
        </div> -->
        <!-- <hr class="h-px bg-gray-300 border-0 dark:bg-gray-700"> -->
        <!-- <div *ngIf="recupTestData"> -->
        <div *ngIf="showTest">
            <div
                class="lg:flex img-ctnr justify-between mb-6 bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                <img [src]="form.get('imageurl')?.value" alt="Image du profil" class="personality-img"
                    style="max-width: 200px; max-height: 200px;" />
                <!-- <img src="https://force-n.sn/wp-content/uploads/2023/04/IMG-20230625-WA0029.jpg"/> -->
            </div>


            <hr class="h-px bg-gray-300 border-0 dark:bg-gray-700">
            <div class="grid lg:grid-cols-3 gap-4 my-3 ml-0">
                <div class="label">Vous êtes :</div>
                <div class="col-span-2">
                    <!-- <input type="text" placeholder="" formControlName="nomProfil" class="bg-white border border-gray-500 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 h-15"  [value]="recupTestData.nomProfil" readonly/> -->
                    <div class="label"><strong>{{recupTestData.nomProfil}}</strong></div>
                </div>
            </div>
            <hr class="h-px bg-gray-300 border-0 dark:bg-gray-700">
            <div class="gap-6 my-3">
                <div class="label"><em>{{recupTestData.baseline}}</em></div>
                <!-- <div class="col-span-2">
                        <input type="text" placeholder="" formControlName="baseLine" class="bg-white border border-gray-500 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 h-15"  [value]="recupTestData.baseline"  readonly/>
                    </div> -->
            </div>
            <hr class="h-px my-2 bg-gray-300 border-0 dark:bg-gray-700">
        </div>
    </div>
</form>
